import { makeAutoObservable } from 'mobx';

interface IUsersPermissionsModel {
  permissions: string[];
}

class ApplicationUserRightsStore {
  permissions: string[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  public IsAllowed(requiredPermissions: string[] | string): boolean {
    if (requiredPermissions instanceof Array) {
      return requiredPermissions.every((v) => this.permissions.includes(v));
    }

    return this.permissions && this.permissions.indexOf(requiredPermissions) > -1;
  }

  setData(data: IUsersPermissionsModel) {
    this.permissions = data.permissions;
  }
}

export const ApplicationUserRights = new ApplicationUserRightsStore();
